import {BehaviorSubject} from 'rxjs';

export const privateProducts$ = new BehaviorSubject({currencyList: [], contractSymbolList: [], spotSymbolList: []});
